module.exports = __webpack_public_path__ + "static/media/globe-africa.ee21e718.svg";